import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { OrderStatusParams, OrderStatusResultModel } from "@tSurya/Services/OrderStatusInfo/OrderStatusService";
import { OrderStatusResultState } from "@tSurya/Store/Data/OrderStatusState";
import { Draft } from "immer";

const initialState: OrderStatusResultState = {
    isLoading: false,
    orderStatusResult: null,
};

const reducer = {
    "Data/OrderStatus/BeginLoadOrderStatus": (
        draft: Draft<OrderStatusResultState>,
        action: { params: OrderStatusParams },
    ) => {
        draft.isLoading = true;
    },
    "Data/OrderStatus/CompleteLoadOrderStatus": (
        draft: Draft<OrderStatusResultState>,
        action: { result: OrderStatusResultModel | null },
    ) => {
        draft.isLoading = false;
        draft.orderStatusResult = action.result;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
